// extracted by mini-css-extract-plugin
export default {"not-found-label":"QTr42Iv0Rp7HFMW","text":"DbswHa3ps0SKkaB"};